import { UpdateStoryForBuilderMeta, UpdateStoryForBuilderPayload } from 'types/store/UpdateStoryForBuilder';
import { createAsyncReducer } from 'utils/Redux';

import { updateStoryForBuilderActions } from '../actions';

export default createAsyncReducer<UpdateStoryForBuilderMeta, UpdateStoryForBuilderPayload>(updateStoryForBuilderActions);
